// Reducer extracted from OrganizationResourcesModule.js

import update from "immutability-helper";
import { UPDATE_FILTERS, INIT_FILTERS } from "./OrganizationResourcesConstants";

// Initial State
const initialState = {
  filters: {
    searchText: "",
    parentFolderId: null,
    types: "TEACHER_RESOURCE",
    visibleTo: ["TEACHER"],
    resourceTags: [],
    isPublishingProgress: false,
    states: ["PUBLISHED"],
  },
};

// Reducer Handlers
const REDUCER_HANDLERS = {
  [INIT_FILTERS]: (state, action) => {
    return update(state, {
      filters: { $set: initialState.filters },
    });
  },
  [UPDATE_FILTERS]: (state, action) => {
    const { key, value } = action.data;
    return update(state, {
      filters: { [key]: { $set: value } },
    });
  },
};

// Reducer
export default function myReducer(state = initialState, action) {
  const handler = REDUCER_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}

// Auto-generated exports
export { initialState, REDUCER_HANDLERS };
